module.exports = __webpack_public_path__ + "img/logo_l.96545677.png";